var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingHazards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5544 1.13227L12.3131 3.45719C12.2852 3.7124 11.9722 3.82206 11.7927 3.64262L11.2225 3.07235L7.6314 6.6634C7.40609 6.88871 7.0093 6.88871 6.78399 6.6634L4.80603 4.68543L1.46423 8.02924C1.34858 8.14487 1.19506 8.2047 1.04152 8.2047C0.887985 8.2047 0.734462 8.14487 0.618811 8.02924C0.385527 7.79594 0.385527 7.4171 0.618811 7.18182L4.38332 3.41731C4.60864 3.19199 5.00542 3.19199 5.22874 3.41731L7.2087 5.39527L10.377 2.22693L9.70906 1.55897C9.52763 1.37752 9.63728 1.06449 9.89251 1.03857L12.2174 0.797297C12.4108 0.775367 12.5743 0.93887 12.5544 1.13227Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingHazards);
export default __webpack_public_path__ + "static/media/TrendingHazards.3731ac89234337f94bf03cdeacb76a78.svg";
export { ForwardRef as ReactComponent };